import { render, staticRenderFns } from "./UploadTitleTips.vue?vue&type=template&id=3f31560a&scoped=true"
import script from "./UploadTitleTips.vue?vue&type=script&lang=js"
export * from "./UploadTitleTips.vue?vue&type=script&lang=js"
import style0 from "./UploadTitleTips.vue?vue&type=style&index=0&id=3f31560a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f31560a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/data/workspace/KCC_AUDIT_PROD_Frontend/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f31560a')) {
      api.createRecord('3f31560a', component.options)
    } else {
      api.reload('3f31560a', component.options)
    }
    module.hot.accept("./UploadTitleTips.vue?vue&type=template&id=3f31560a&scoped=true", function () {
      api.rerender('3f31560a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/UploadTitleTips.vue"
export default component.exports